import React from 'react';

import cx from 'classnames';
import { isEmpty } from 'lodash';

import { UserIcon } from '@/assets/icons';

import styles from './Avatar.module.scss';

interface IAvatarProps {
	name: string;
	className?: string;
}

const Avatar = ({ name, className }: IAvatarProps) => {
	const getInitials = () => {
		if (!isEmpty(name) && isNaN(Number(name.charAt(0)))) {
			const trimmedName = name.trim();
			const [first, last] = trimmedName.split(' ');
			const initials = first.charAt(0) + (last ? last.charAt(0) : '');
			return initials.toUpperCase();
		}
		return <UserIcon width={48} height={48} />;
	};

	return <div className={cx(styles.avatar, className)}>{getInitials()}</div>;
};

export default Avatar;
